var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container is-fluid"},[_c('div',[_c('Filters')],1),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('List')],1)])]),(_vm.showPlayerOverlay)?_c('Player'):_vm._e(),(_vm.showMatchOverlay)?_c('SceneMatch'):_vm._e(),(_vm.showCreateOverlay)?_c('CreateScene'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }